import * as yup from 'yup';

// Schémas de validation Yup
const reducedIndividualPersonValidationSchema = yup.object().shape({
    civility: yup.string().required('La civilité est requise'),
    firstName: yup
        .string()
        .required('Le prénom est requis'),
    lastName: yup
        .string()
        .required('Le nom est requis')
});

export default reducedIndividualPersonValidationSchema